import axios from "axios"
import { URL } from "./settings"

export default class AdminService {
    static async addContext(userId, contextId) {
        const response = await axios.post(`${URL}/user/${userId}/context/${contextId}`,
            {},
            { withCredentials: true }
        )
        console.log("UserService::addContext response", response)
        return response
    }

    static async deleteContext(userId, contextId) {
        try {
            const response = await axios.delete(`${URL}/user/${userId}/context/${contextId}`,
                { withCredentials: true }
            )
            console.log("UserService::deleteContext response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
    
    static async createMailingStatus(title, gap) {
        try {
            const response = await axios.post(`${URL}/admin/renewals/mailing_status/`, 
                {
                    title: title,
                    gap: gap,
                }, 
                { withCredentials: true }
            )
            console.log("AdminService::createMailingStatus response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async deleteMailingStatus(statusId) {
        try {
            const response = await axios.delete(`${URL}/admin/renewals/mailing_status/${statusId}`, 
                { withCredentials: true }
            )
            console.log("AdminService::deleteMailingStatus response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async updateMailingStatus(statusId, title, gap) {
        try {
            const response = await axios.patch(`${URL}/admin/renewals/mailing_status/${statusId}`,
                {
                    title: title,
                    gap: gap,
                },
                { withCredentials: true }
            )
            console.log("AdminService::updateMailingStatus response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async createPurchaseTag(title) {
        try {
            const response = await axios.post(`${URL}/admin/my_students/tag/`,
                { title: title },
                { withCredentials: true }
            )
            console.log("AdminService::createPurchaseTag response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }

    static async deletePurchaseTag(tagId) {
        try {
            const response = await axios.delete(`${URL}/admin/my_students/tag/${tagId}`,
                { withCredentials: true }
            )
            console.log("AdminService::deletePurchaseTag response", response)
            return response
        } catch (error) {
            console.log(error)
            return error.response
        }
    }
}
